import { Distance } from "components/Panel/Distance";

/** Components Area and Distance are identical */
export const Area = Distance;
